import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function PageHeader({ eyebrow, title, description, crumbs = [] }) {
  return (
    <section className='relative pt-36 pb-20 border-b border-brand/10 overflow-hidden'>
      <div className='absolute inset-0'>
        <div className='orb orb-brand w-[700px] h-[500px] -top-24 left-1/2 -translate-x-1/2' />
        <div className='orb orb-pink w-[400px] h-[400px] bottom-0 right-10' />
      </div>
      <div className='relative max-w-6xl mx-auto px-6'>
        {crumbs.length > 0 && (
          <nav className='flex items-center gap-1.5 text-[13px] text-white/50 mb-6 font-accent'>
            <Link to='/' className='hover:text-brand transition-colors'>Home</Link>
            {crumbs.map((c, i) => (
              <span key={i} className='flex items-center gap-1.5'>
                <ChevronRight className='w-3.5 h-3.5' />
                {c.to ? <Link to={c.to} className='hover:text-brand transition-colors'>{c.label}</Link> : <span className='text-white/85'>{c.label}</span>}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && <div className='eyebrow-pill'>{eyebrow}</div>}
        <h1 className='mt-6 font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.02]'>
          {title}
        </h1>
        {description && (
          <p className='mt-6 text-lg text-white/70 max-w-2xl leading-relaxed font-body'>{description}</p>
        )}
      </div>
    </section>
  );
}
